import gql from 'graphql-tag'

export const answerSurvey = gql`
mutation answerSurvey($answersJson: String!, $managerEmail: String, $currentDay: Int) {
  answerSurvey(answersJson: $answersJson, managerEmail: $managerEmail,currentDay: $currentDay) {
    status
    answer{
      id
      stats
    }
  }
}
`;

export const answerSurveyKyper = gql`
mutation answerSurvey($answersJson: String!, $managerEmail: String, $managerEmails: [String!], $currentDay: Int, $screenContentId: Int, $stepId: Int) {
 answerSurvey(
   answersJson: $answersJson
   managerEmail: $managerEmail
   managerEmails: $managerEmails
   currentDay: $currentDay
   screenContentId: $screenContentId
   stepId: $stepId
 ) {
   status
   answer {
     id
     stats
     __typename
   }
   __typename
 }
}
`;
